import {IntegrationId} from '@webmate-web-core/shared/types/ids';
import {WMValue, WMDatatype} from './base-types';
import {ObservationData} from './testmgmt';

export type IssueReporterType = 'alm' | 'jira';

export enum IssueSourceType {
    Finding = 'finding',
    TestRun = 'testrun'
}

export interface IssueReporterIntegration {
    id: IntegrationId;
    name: string;
    description: string;
    enabled: boolean;
    issueReporterType: IssueReporterType;
    config: any;
}

export interface IssueReporterInsertDTO {
    name: string;
    description: string;
    enabled: boolean;
    issueReporterType: IssueReporterType;
    config: any;
}

export interface IssueReporterProjectWithIssueTypes {
    id: string;
    key: string;
    name: string;
    issueTypes: Array<[string, string]>;
}

export interface IssueReporterParameter {
    name: string;
    parameterType: WMDatatype;
    required: boolean;
    optDescription?: string;
    optDisplayName?: string;
    possibleValues?: Array<[string, string]>;
    size?: number;
    default?: WMValue<any>;
}

export interface IssueReporterParametersResponse {
    parameters: IssueReporterParameter[];
    supportsAttachments?: boolean;
}

export interface IssueReporterAttachment {
    observation: ObservationData;
    displayName: string;
    note?: string | null;
}

export interface IssueReporterDefaults {
    parameterDefaults: { [key: string]: WMValue<any> };
    availableAttachments: IssueReporterAttachment[];
}

export interface IssueReportingInfo {
    id: string;
}

export const NEW_INTEGRATION_ID = '00000000-0000-0000-0000-000000000000';
